import { styled } from '@mui/material';
import { useGetBase64Image } from '../hooks/UseGetBase64Image';

interface Props {
  src: string;
  fit?: 'cover' | 'contain' | 'fill' | 'none' | 'scale-down';
}

function ImageComponent({ src, fit = 'cover' }: Props) {
  const Image = styled('img')({
    width: '100%',
    height: '100%',
    objectFit: fit,
  });

  const base64Image = useGetBase64Image(src);

  return (
    <Image
      src={base64Image}
      alt=""
      loading="lazy"
    />
  );
}

export default ImageComponent;
